module.exports = "<navbar></navbar>\n<router-outlet></router-outlet>\n<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <p class=\"text-right\">Version {{appVersion}}</p>\n    </div>\n  </div>\n</div>\n<div class=\"toggle-container\">\n  <a (click)=\"toggleContainer()\"><span class=\"fa fa-arrows-h\"></span></a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main